import { FC, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SometimesInlineFiltersCheckBox } from './Filters.styles';
import { FilterOptions } from '../../reducers/filters.types';

import { updateFilter, mustHavesSelector } from '../../reducers/filters';
import { listItemToggle } from '../helpers';

export const SelectFeatures: FC = () => {
    const reduxDispatch = useDispatch();

    const { selectedValue: mustHaves, options } =
        useSelector(mustHavesSelector);

    const onFeaturesChange = (evt: ChangeEvent<HTMLInputElement>) => {
        const newMustHaves = listItemToggle(mustHaves, evt.currentTarget.value);
        reduxDispatch(updateFilter('mustHaves', newMustHaves));
    };

    return (
        <>
            <FeaturesCheckboxes
                mustHaveOptions={options}
                onFeaturesChange={onFeaturesChange}
                mustHaves={mustHaves}
            />
        </>
    );
};

type Props = {
    mustHaveOptions: FilterOptions;
    onFeaturesChange: (evt: ChangeEvent<HTMLInputElement>) => void;
    mustHaves: string[];
};

const FeaturesCheckboxes: FC<Props> = ({
    mustHaveOptions,
    onFeaturesChange,
    mustHaves
}) => (
    <>
        {mustHaveOptions?.map((mustHaveOption, index) => {
            const { value, label } = mustHaveOption;

            const isChecked = mustHaves.includes(value);

            return (
                <SometimesInlineFiltersCheckBox
                    id={value}
                    key={`${value}-${index}`}
                    value={value}
                    onChange={onFeaturesChange}
                    label={label}
                    checked={isChecked}
                />
            );
        })}
    </>
);
